export class Menu
{
    constructor(public folderName?:string,public pptxFile?:string,public wordFile?:string,public image?:string,public textFile?:string, public pdfFile?:string)
    {

    }
}